import React, { useState } from 'react';
import { FaRulerCombined, FaRuler, FaBan } from 'react-icons/fa';
import './MeasurementPanel.css';

const MeasurementPanel = ({
    setActiveMode,
    handleDestroyMeasurement,
    measurementResult,
}) => {
    const [activeTool, setActiveTool] = useState(null);

    const handleMeasureArea = () => {
        setActiveMode('measureArea');
    };
    const handleMeasureDistance = () => {
        setActiveMode('measureDistance');
    };
    
    const handleAreaClick = () => {
        if (activeTool === 'area') {
            setActiveTool(null);
            handleDestroyMeasurement();
        } else {
            setActiveTool('area');
            handleMeasureArea();
        }
    };

    const handleDistanceClick = () => {
        if (activeTool === 'distance') {
            setActiveTool(null);
            handleDestroyMeasurement();
        } else {
            setActiveTool('distance');
            handleMeasureDistance();
        }
    };

    const handleCancelClick = () => {
        setActiveTool(null);
        handleDestroyMeasurement();
    };

    return (
        <div className="measurement-panel">
            <button
                className={`measurement-button ${activeTool === 'area' ? 'active' : ''}`}
                onClick={handleAreaClick}
            >
                <FaRulerCombined className="measurement-icon" />
                Mjerenje površine
            </button>

            <button
                className={`measurement-button ${activeTool === 'distance' ? 'active' : ''}`}
                onClick={handleDistanceClick}
            >
                <FaRuler className="measurement-icon" />
                Mjerenje rastojanja
            </button>

            {measurementResult && (
                <div className="measurement-result">
                    <span>{measurementResult}</span>
                </div>
            )}

            {measurementResult !== null && (
                <button
                    className="measurement-button cancel"
                    onClick={handleCancelClick}
                >
                    <FaBan className="measurement-icon" />
                    Poništi mjerenje
                </button>
            )}
        </div>
    );
};

export default MeasurementPanel;
